import {Link} from "react-router-dom";
import React from "react";

const SidebarLinkItems = ({link , icon , config , title}) => {
    return(
        <Link to={link} style={{display:'flex' , alignItems: 'center' , width: '100%' , height: '100%' , marginBottom:'8px'}} >
            {
                config ?
                    <div className={'non-collapse-menu'}>
                        <span>{title}</span>
                    </div>
                    :
                    <div className={'collapse-menu-link-Items'}>
                        {icon}
                    </div>
            }
        </Link>
    )
}

export default SidebarLinkItems;